export const SIDEBAR_FILE_DRAG_TYPE = 'application/x-sidebar-file';
const SIDEBAR_FILE_DRAG_PREFIX = 'sidebar-file:';

function dataTransferTypes(dataTransfer) {
  if (!dataTransfer || !dataTransfer.types) {
    return [];
  }
  return Array.from(dataTransfer.types);
}

function sidebarFilePayload(item) {
  if (!item || item.id == null || !item.url) {
    return null;
  }
  return {
    id: item.id,
    url: item.url,
    name: item.name || '',
  };
}

function payloadsFromRaw(raw) {
  if (!raw) {
    return [];
  }
  try {
    const payload = JSON.parse(raw);
    const list = Array.isArray(payload) ? payload : [payload];
    return list.filter((item) => item && item.id != null && item.url);
  } catch {
    return [];
  }
}

// One image, or the current multi-selection when that image is already selected.
export function setSidebarFileDragData(dataTransfer, itemOrItems) {
  if (!dataTransfer) {
    return false;
  }
  const items = Array.isArray(itemOrItems) ? itemOrItems : [itemOrItems];
  const payloads = items.map(sidebarFilePayload).filter(Boolean);
  if (!payloads.length) {
    return false;
  }
  const encoded = JSON.stringify(payloads.length === 1 ? payloads[0] : payloads);
  dataTransfer.setData(SIDEBAR_FILE_DRAG_TYPE, encoded);
  // Safari drops custom MIME types. The prefix keeps text/plain from looking like a
  // file-browser move payload, which JSON.parses text/plain as a user file id.
  dataTransfer.setData('text/plain', `${SIDEBAR_FILE_DRAG_PREFIX}${encoded}`);
  dataTransfer.effectAllowed = 'copy';
  return true;
}

export function hasSidebarFileDrag(event) {
  return dataTransferTypes(event && event.dataTransfer).includes(SIDEBAR_FILE_DRAG_TYPE);
}

function readSidebarFileDragRaw(event) {
  const dataTransfer = event && event.dataTransfer;
  if (!dataTransfer) {
    return '';
  }
  let raw = '';
  try {
    raw = dataTransfer.getData(SIDEBAR_FILE_DRAG_TYPE) || '';
  } catch {
    raw = '';
  }
  if (raw) {
    return raw;
  }
  try {
    const plain = dataTransfer.getData('text/plain') || '';
    if (plain.startsWith(SIDEBAR_FILE_DRAG_PREFIX)) {
      return plain.slice(SIDEBAR_FILE_DRAG_PREFIX.length);
    }
  } catch {
    return '';
  }
  return '';
}

export function parseSidebarFileDragList(event) {
  return payloadsFromRaw(readSidebarFileDragRaw(event));
}
